import { compose } from 'recompose'
import { withRootDir, initializeClientRoutes } from 'src/composables'

const AppContainer = compose(
  withRootDir,
  initializeClientRoutes
)

export default AppContainer
